const screen = {
  xs: '(min-width: 320px)',
  sm: '(min-width: 544px)',
  md: '(min-width: 768px)',
  lg: '(min-width: 992px)',
  xl: '(min-width: 1170px)',
  xxl: '(min-width: 1440px)',

  max: {
    xs: '(max-width: 319px)',
    sm: '(max-width: 543px)',
    md: '(max-width: 767px)',
    lg: '(max-width: 991px)',
    xl: '(max-width: 1169px)',
    xxl: '(max-width: 1439px)',
  },
};

export default screen;
